import React from "react";
import { Modal, Carousel } from "react-bootstrap";
import Image from "react-bootstrap/Image";

const PreviewModal = ({ show, onHide, content, type }) => {
  const isMedia = type === "image" || type === "video";

  return (
    <Modal
      show={show}
      onHide={onHide}
      fullscreen={isMedia}
      size={!isMedia ? "lg" : undefined}
      centered={!isMedia}
      className={`preview-modal ${isMedia ? 'overlay-modal' : ''}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`${isMedia ? 'p-0 d-flex align-items-center justify-content-center' : 'p-4'}`} 
        style={isMedia ? { background: 'rgba(0,0,0,0.9)' } : {}}>
        {type === "image" && Array.isArray(content) ? (
          <Carousel interval={null} className="w-100">
            {content.map((image, index) => (
              <Carousel.Item key={index}>
                <Image
                  src={image.file}
                  style={{
                    width: "100vw",
                    height: "90vh",
                    objectFit: "contain",
                  }}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : type === "image" ? (
          <Image
            src={content}
            style={{
              width: "100vw",
              height: "90vh",
              objectFit: "contain",
            }}
          />
        ) : type === "video" ? (
          <video
            controls
            style={{
              width: "100vw",
              height: "90vh",
              objectFit: "contain",
            }}
          >
            <source src={content} />
          </video>
        ) : (
          <div className="preview-text">{content}</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PreviewModal;
